import {getNestedValue} from "../../utils/arr-path";
import {equalDeep}      from "../../utils/objects";
import {cs}             from "../chain-services";
import {scopedState}    from "../scoped-state";

export const CsForm = ({data, fields, next}) => cs(
    ({}) => {
        const fields1 = !fields ? [] : fields.map(({path, validators}) => {
            const failedValidator = validators?.find((validator) => !validator.validate(
                getNestedValue(data.value, path),
                {data: data.value},
            ));
            const error = failedValidator && {failedValidator};
            return ({
                path,
                error,
                valid: !error,
                validators,
            });
        });

        return next({
            fields1,
            field: (path) => {
                const field1 = fields1.find((f1) => equalDeep(f1.path, path));
                return ({
                    state: scopedState(data, path),
                    error     : field1 && field1.error,
                    validators: field1 && field1.validators,
                });
            },
            valid: !fields1.find(({valid}) => !valid),
        });
    },
);
